/** @jsxImportSource @emotion/react */
import { Link } from "react-router-dom";

import { CHECK_LOCATION, LAYER_TYPE } from "../../../../actions/Layers/constants";
import { AVOCADO_FRUIT } from "../../../../actions/Tenants/config/fruitNames";
import { useLayerChecks } from "../../../../hooks/useLayerChecks";
import { Loading } from "../../../Helper/Loading";
import { toFixed } from "../fields/formatters";
import { MetaRow } from "./LayerMeta";

import { useRouteLayer, useRouteLayerQuery } from "../../../../hooks/useCurrentEntities";

export function LayerLabResults() {
    const isLoading = useRouteLayerQuery().isLoading;
    const layer = useRouteLayer();
    const { data: checks = [] } = useLayerChecks(layer?.tenant_id, layer?.id ?? undefined);
    const labChecks = checks.filter((i) => i.location === CHECK_LOCATION.LAB_CHECK).sort((a, b) => b.check_id - a.check_id);

    if (isLoading) {
        return <Loading />;
    }
    // TODO: refactor to use the display_filter
    return <>
        {layer.type === LAYER_TYPE.PURCHASE_ORDER && <div className="pt-4">
            {layer.fruit_type === AVOCADO_FRUIT && <div>
                {labChecks.map((i:any, index) => <MetaRow key={index} label={"AVG dry matter"} value={<Link to={`/layer/${layer.id}/add-check/${i.check_id}/summary`}> {`${toFixed(
                    i.dry_matter_avg || i.manual_dry_matter_avg
                    || i.average_manual_dry_matter, // This is a hack to support old data, please don't use this key instead use manual_dry_matter_avg
                    2
                )} %`}</Link>}></MetaRow>)}
            </div>}
        </div>}
    </>;
}
